import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const TerminalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
`;

const TerminalWindow = styled.div`
  width: 80%;
  max-width: 800px;
  height: 60%;
  background-color: #000;
  border: 2px solid #00ff00;
  border-radius: 5px;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const TerminalOutput = styled.div`
  flex-grow: 1;
  margin-bottom: 10px;
  font-size: 1.6rem;
  white-space: pre-wrap;
`;

const TerminalInput = styled.div`
  display: flex;
  width: 100%;
`;

const Prompt = styled.span`
  color: #00ff00;
  margin-right: 10px;
`;

const Input = styled.input`
  background-color: transparent;
  border: none;
  color: #00ff00;
  font-size: 1.6rem;
  flex-grow: 1;
  outline: none;
  caret-color: #00ff00;
`;

const Cursor = styled.span`
  display: inline-block;
  width: 12px;
  height: 1.6rem;
  background-color: #00ff00;
  margin-left: 2px;
  animation: blink 1s step-end infinite;
  
  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }
`;

const Terminal = ({ onLogin }) => {
  const [output, setOutput] = useState([
    "LUMON INDUSTRIES TERMINAL",
    "MDR DIVISION ACCESS",
    "",
    "PLEASE AUTHENTICATE",
    ""
  ]);
  const [input, setInput] = useState("");
  const [prompt, setPrompt] = useState(">");
  const [loginStage, setLoginStage] = useState(0);
  const [username, setUsername] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [prompt, loginStage]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      processCommand();
    }
  };

  const processCommand = () => {
    const newOutput = [...output, `${prompt} ${input}`];
    
    if (loginStage === 0) {
      if (input.toLowerCase() === 'login') {
        newOutput.push("", "ENTER USERNAME:");
        setPrompt("USERNAME:");
        setLoginStage(1);
      } else {
        newOutput.push("", "UNKNOWN COMMAND. TRY 'LOGIN'");
      }
    } else if (loginStage === 1) {
      setUsername(input);
      newOutput.push("", "ENTER USER ID:");
      setPrompt("USER ID:");
      setLoginStage(2);
    } else if (loginStage === 2) {
      // setUserId removed(input);
      newOutput.push("", "AUTHENTICATING...", "");
      setTimeout(() => {
        setOutput([...newOutput, "ACCESS GRANTED", "", "WELCOME TO LUMON INDUSTRIES", "INITIALIZING MDR INTERFACE..."]);
        setTimeout(() => {
          onLogin(username, input);
        }, 2000);
      }, 1500);
    }
    
    setOutput(newOutput);
    setInput("");
  };

  return (
    <TerminalContainer>
      <TerminalWindow>
        <TerminalOutput>
          {output.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </TerminalOutput>
        <TerminalInput>
          <Prompt>{prompt}</Prompt>
          <Input
            ref={inputRef}
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
          <Cursor />
        </TerminalInput>
      </TerminalWindow>
    </TerminalContainer>
  );
};

export default Terminal;
